import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Dialog, H6 } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import Chart from 'react-apexcharts';
import '../results.css';
import { rounded }  from '../../../utils.js';
import {estimatedClass} from '../common';
import {MAX_CHART_SIZE} from '../../../constants.js';
import RealSpecPopup  from './RealSpecPopup.js';
import InnerCollocsDetailsPopup from './InnerCollocsDetailsPopup.js';

class DetailByReal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      isOpenModal:false,
      isOpenModal2:false,
      currentKey:0 // the current key for the realSpec chart or the innerCollocsDetail chart
    };
  }

  realSpecPopup = (e) => {
    this.setState({currentKey:e.target.value});
    this.toggleModal();
  };
  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  innerCollocsDetailsPopup = (e) => {
    this.setState({currentKey:e.target.value});
    console.log("value=",e.target.value);
    this.toggleModal2();
  };
  toggleModal2 = () => {
    this.setState(prevState => ({ isOpenModal2: !prevState.isOpenModal2 }));
  }

  render() {
    // Two kinds of realizations depending on tokenId ("full" or "1", "2", for individual tokens etc.)
    // Cmp button, innerAssoc, disp and surf are displayed only for "full" realization 
    const corpusStats = this.props.corpusStats;
    const type = (this.props.type === 'dispByReal') ? 'disp' : (this.props.type === 'freqByReal') ? 'freq' : 'spec';
    const t = this.props.t;
    const incompleteExtraction = this.props.incompleteExtraction;
    const { isOpenModal, isOpenModal2 } = this.state;

    let data = [];
    let innerAssocCol=false;
    let displayDisp=false;
    let averageSurfCol=false;
    for (const real in corpusStats) {
      const row = {
        real: real,
        value: corpusStats[real][type],
        freq: corpusStats[real]["freq"],
        disp: (typeof corpusStats[real]["disp"]!=='undefined')? corpusStats[real]["disp"]:"",
      };
      if (typeof corpusStats[real]["disp"]!=='undefined') {
        displayDisp=true;
      }
      // console.log(real,"=>",corpusStats[real]);
      if (corpusStats[real].innerCollocs) {
        row.innerAssoc=rounded(corpusStats[real].innerCollocs.innerAssoc,2);
        innerAssocCol=true;
      }
      if (corpusStats[real].surf) {
        row.averageSurf=corpusStats[real].surf
        averageSurfCol=true;
      }
      data.push(row);
    }


    // sort data by decreasing order
    data.sort((a, b) => a.value - b.value);
    data.reverse();
    const dataChart=data.slice(0,MAX_CHART_SIZE);

    const typeLabel = (type === 'disp') ? t('dispersion') : (type === 'freq') ? t('frequency') : t('specificity') ;
    const typeLabelLower = typeLabel.toLowerCase();
    const columnDef= [
      { title: t('realization'), field: "real" },
      { 
        title: t('frequency'),  
        field: 'freq', 
        render: rowData => <span className={estimatedClass(rowData.value,incompleteExtraction)}>{rounded(rowData.freq)}</span>
      }];
    
    if (displayDisp) { 
      columnDef.push(
        { 
          title: t('dispersion'),  
          field: 'disp', 
          render: rowData => <span className={estimatedClass(rowData.value,incompleteExtraction)}>{rounded(rowData.disp)}</span>
        }
      );
    }
    if (innerAssocCol) {
      columnDef.push(
        { 
          title: t('innerAssoc'), 
          field: 'innerAssoc',
          render: rowData => <button value={rowData.real} onClick={this.innerCollocsDetailsPopup}>{rowData.innerAssoc}</button>,
        }      
      )
    }
    if (averageSurfCol) {
      columnDef.push(
        { 
          title: t('averageSurf'), 
          field: 'averageSurf',
          render: rowData => <span className={estimatedClass(rowData.averageSurf,incompleteExtraction)}>{rounded(rowData.averageSurf,2)}</span>
        }      
      )
    }
    // cmp button only for full realization
    if (this.props.tokenId==="full") {
      columnDef.push(
        {
          title: t('compare'),
          render: rowData => <button value={rowData.real} onClick={this.realSpecPopup}>cmp</button>,
        }
      );
    }

    const realsTable = (
      <MaterialTable
        columns={columnDef}
        data={data}
        title={`${typeLabel} ${t('byReal')}`}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${typeLabelLower}_by_realization`,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 25, 50, 100, data.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    // prep data for the chart

    const series = [{
        name:typeLabel,
        data:dataChart.map(e=>e.value)
    }];
    const options = {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          columnWidth: '80%',
        }
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        title: {
          text: typeLabel,
        },
        labels: {
          formatter: function (y) {
            return rounded(y,2);
          }
        }
      },
      xaxis: {
        type: 'text',
        categories: dataChart.map(el=>(el.real)),
        labels: {
          rotate: -90
        }
      }
    }

    return(
      <>
        <div className="margin-bottom-1-rem">
          <H6><u>{t('graphicalRepr')}</u></H6>
          <div id="chart">
             <Chart options={options} series={series} type="bar" height={350} />
          </div>
        </div>

        <H6><u>{t('completeResList')}</u></H6>
        {realsTable}
        
        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('realSpecComparisonBtn')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          <RealSpecPopup realization={this.state['currentKey']} data={this.props.realSpec[this.state['currentKey']]}/>
        </Dialog>

        <Dialog
            isOpen={isOpenModal2}
            onClose={this.toggleModal2}
            title={t('innerCollocsDetails')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          { this.state['currentKey'] && corpusStats[this.state['currentKey']] && corpusStats[this.state['currentKey']].innerCollocs &&
            <InnerCollocsDetailsPopup realization={this.state['currentKey']} data={corpusStats[this.state['currentKey']].innerCollocs.pairs} />
          }
        </Dialog>

      </>
    );
  }
}

DetailByReal.propTypes = {
  tokenId: PropTypes.string,
  corpusStats: PropTypes.object,
  type: PropTypes.string,
  realSpec: PropTypes.object,
  incompleteExtraction:PropTypes.bool
};

export default withTranslation()(DetailByReal);
